import { Stepper, StepperStep } from "@dgs/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useEventType } from "../eventTypes/EventTypeProvider";

const Wrapper = styled.div`
	padding-top: ${({ theme }) => theme.spacing(4)};
	flex-basis: 100%;
`;

export const EventTypeStepper = () => {
	const { t } = useTranslation();
	const { currentCreateStep } = useEventType();

	const steps: StepperStep[] = [
		{ status: "inactive", label: t("Create") },
		{ status: "inactive", label: t("Configure") },
	];

	if (currentCreateStep === "base") {
		steps[0].status = "active";
		steps[1].status = "inactive";
	} else {
		steps[0].status = "done";
		steps[1].status = "active";
	}

	return (
		<Wrapper>
			<Stepper currentStepIndex={currentCreateStep === "base" ? 0 : 1} steps={steps} />
		</Wrapper>
	);
};
